<template>
  <div>
    <b-button
      v-if="celloutput.length > 0 || isStartjaar"
      :id="`popover-${$vnode.key}`"
      :variant="isStartjaar ? 'success' : 'secondary'"
      block
      size="sm"
      squared
    >
      {{ celloutput.length > 0 ? totaalbedrag : "-" }}
      <b-badge 
        v-if="celloutput.length > 1" 
        pill 
        variant="info"
      >
        {{
          celloutput.length
        }}
      </b-badge>
      <i 
        v-if="isStartjaar" 
        class="fa fa-play" 
        variant="info"
      />
    </b-button>

    <span v-else><slot /></span>

    <b-popover
      v-if="celloutput.length > 0"
      :target="`popover-${$vnode.key}`"
      triggers="hover focus"
      placement="bottomleft"
      title="Details"
      custom-class="wide-popover"
    >
      <b-list-group style="width: 300px">
        <b-list-group-item
          v-for="(item, index1) in acties"
          :key="'actie ' + index1"
          class="d-flex justify-content-between align-items-center"
        >
          <h6>
            <i
              :class="isStartjaar ? 'fa-play' : 'fa-refresh'"
              class="fa mb-1 mr-2"
            />
            {{ item.actie.naam }} {{ item.actie.operator }}
            <b-badge>x {{ multiplier }}</b-badge>
            <!---<small v-if="item.offset !== 0">{{item.jaar}} ({{item.offset}})</small>--->
          </h6>

          <b-button-group>
            <b-dropdown 
              no-caret 
              size="sm"
            >
              <template #button-content>
                {{ item.actie.jaren.length }}
                <font-awesome-icon icon="thumbtack" />
              </template>

              <b-dropdown-item>
                <b-button-group>
                  <b-button
                    v-for="i in 10"
                    :key="i"
                    :variant="
                      item.actie.jaren.map((a) => a.jaar).includes(jaar - 5 + i)
                        ? 'info'
                        : 'secondary'
                    "
                    @click="() => toggle(item.actie.jaren, jaar - 5 + i)"
                  >
                    {{ jaar - 5 + i }}
                  </b-button>
                </b-button-group>
              </b-dropdown-item>
            </b-dropdown>
            <b-checkbox
              v-model="item.actie.stuck"
              :button-variant="item.actie.stuck ? 'info' : 'outline-info'"
              :title="
                item.stuck
                  ? 'Magneten hebben geen effect'
                  : 'Magneten hebben effect'
              "
              button
              size="sm"
            >
              <font-awesome-icon 
                icon="magnet"
              />
            </b-checkbox>
          </b-button-group>
        </b-list-group-item>

        <b-list-group-item
          v-for="(item, index2) in gebreken"
          :key="'gebrek ' + index2"
          class="d-flex w-100 justify-content-between align-items-center"
        >
          <h6>
            <i class="fa mb-1 mr-2 fa-exclamation-triangle" />
            {{ item.omschrijving }} {{ item.bedrag }}
            <!---<small v-if="item.offset !== 0">{{item.jaar}} ({{item.offset}})</small>--->
          </h6>

          <b-checkbox
            v-model="item.stuck"
            :title="
              item.stuck
                ? 'Magneten hebben geen effect'
                : 'Magneten hebben effect'
            "
            :button-variant="item.stuck ? 'info' : 'outline-info'"
            button
            size="sm"
          >
            <font-awesome-icon 
              icon="magnet"
            />
          </b-checkbox>
        </b-list-group-item>
        <b-list-group-item variant="secondary">
          <h4>Totaal {{ totaalbedrag }}</h4>
        </b-list-group-item>
      </b-list-group>
    </b-popover>
  </div>
</template>
<script>
import FontAwesome from '../icons/FontAwesome.vue'

export default {
  name: "Cell",
  components: { FontAwesome },
  props: {
    row: {
      type: Object,
      default: null,
    },
    multiplier: {
      type: Number,
      default: 1,
    },
    jaar: {
      type: Number,
      default: null,
    },
    startjaar: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    hasJaar: function () {
      return this.resultaat[this.jaar] != null;
    },
    celloutput: function () {
      return this.acties.concat(this.gebreken);
    },
    acties: function () {
      return this.row.acties.filter((a) => a.jaren.includes(this.jaar));
    },
    gebreken: function () {
      return this.row.gebreken.filter((g) => g.planning == this.jaar);
    },
    totaalbedrag: function () {
      var totaalacties = this.acties.reduce(
        (a, b) =>
          a +
          (b.startjaar === this.jaar
            ? b.actie.startbedrag || 0
            : b.actie.bedrag),
        0
      );
      var totaalgebreken = this.gebreken.reduce((a, b) => a + b.bedrag, 0);
      return Math.round(
        Number(totaalacties * this.multiplier) + Number(totaalgebreken)
      );
    },
    isStartjaar: function () {
      return this.jaar == this.startjaar;
    },
  },
  methods: {
    toggle(jaren, jaar) {
      if (jaren.map((a) => a.jaar).includes(jaar)) {
        // verwijderen
        jaren.forEach((item, index) => { if (item.jaar == jaar)  jaren.splice(index,1) }); 
          // .forEach((index) => console.log(index));
      } else {
        // toevoegen
        console.log("toevoegen");
        jaren.push({
          jaar: jaar,
          uitgevoerd: false,
          stuck: false,
        });
      }
    },
  },
};
</script>
<style scoped>
.wide-popover {
  max-width: 800px;
}
</style>